import { useEffect, useRef } from "react";
import { pushPageView } from "../../utils/gtm";

/**
 * Dispara `page_view` na carga inicial e a cada troca de rota.
 *
 * O container do GTM já emite o pageview nativo no carregamento do documento,
 * mas navegações da SPA (como `/` → `/cadastro-sucesso`) não recarregam a
 * página e ficariam sem registro.
 *
 * O `ref` evita o disparo duplicado que o StrictMode causa em desenvolvimento,
 * ao remontar o efeito com o mesmo `pathname`.
 */
export function usePageView(pathname: string): void {
  const tracked = useRef<string>();

  useEffect(() => {
    if (tracked.current === pathname) return;
    tracked.current = pathname;
    pushPageView(window.location.hostname + pathname);
  }, [pathname]);
}
